import { Component, Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
const I18N_VALUES = {
  'en': {
    weekdays: ["Mo", "Tu", "We", "Th", "Fr", "Sa","Su"],
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  },
  'ar': {
    weekdays: ['الأثنين', 'الثلاثاء','الأربعاء','الخميس','الجمعة','السبت','الأحد'],
    months: ['يناير', 'فبراير', 'مارس', 'ابريل', 'مايو', 'يونيو', 'يوليو', 'اغسطس.', 'سبتمبر', 'اكتوبر', 'نوفمبر', 'ديسيمبر'],
  },
};

@Injectable()
export class I18n {
  language= this.translate.currentLang;
  constructor(private translate: TranslateService) {
  }
}

@Injectable()
export class DatepicketLocalizationService extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
